import React from "react";
import { Tooltip } from "@fluentui/react-components";
import { Info20Regular } from "@fluentui/react-icons";
import styles from "./section.module.scss";

export interface SectionProps {
    headerMessage: string;
    body?: React.ReactNode;
    tooltipMessage?: string;
    headerNode?: React.ReactNode;
}

const Section: React.FC<SectionProps> = (props: SectionProps) => {
    return (
        <div className={styles.segment}>
            <div className={styles.headerRow}>
                <div className={styles.messageWithTooltip}>
                    <p>{props.headerMessage}</p>
                    {props.tooltipMessage && (
                        <Tooltip content={props.tooltipMessage} relationship="label">
                            <Info20Regular />
                        </Tooltip>
                    )}
                </div>
                {props.headerNode}
            </div>
            {props.body}
        </div>
    );
};

export default Section;
